import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsSurfingNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.51.3c-.18 0-4.38.08-8.6 4.3a25.49 25.49 0 00-5.58 7.82 1 1 0 00.1.93 1 1 0 00.83.43H2v.77a1 1 0 00.43.83 1.06 1.06 0 00.57.17.92.92 0 00.36-.07 25.62 25.62 0 007.82-5.57c3.94-3.91 4.29-7.83 4.32-8.5a.41.41 0 000-.11 1 1 0 00-.99-1zm-7.9 5a13.27 13.27 0 017.1-3.92l-2 2-9.41 9.4h-1a24.7 24.7 0 015.31-7.47zm3.89 3.9A24.7 24.7 0 013 14.55v-1.08l9-9 .19-.18.2-.21 2-2A13.27 13.27 0 0110.5 9.2z"
  }));
});
SvgSportsSurfingNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsSurfingNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsSurfingNormalXsmall;